// Parses direct and exact-adjacent `var(...)` tokens for transform passes.
// Example: readAdjacentVarReferenceAt(".bp-&var(--bp[0].name)", 4).
import { parseVarReferenceAt } from './scanner'
import type { AdjacentVarReference } from './types'

// Read one direct `var(...)` or exact `&var(...)` token at one source index.
export function readAdjacentVarReferenceAt(source: string, startIndex: number): AdjacentVarReference | null {
  const directReference = parseVarReferenceAt(source, startIndex)
  // Return direct var references without ampersand metadata.
  if (directReference) {
    return {
      tokenStart: startIndex,
      raw: directReference.raw,
      hasAmpersandPrefix: false,
      reference: directReference,
    }
  } else if (source[startIndex] !== '&') {
    // Reject non-adjacent positions quickly.
    return null
  } else {
    // Continue exact `&var(...)` detection.
  }

  const adjacentReference = parseVarReferenceAt(source, startIndex + 1)
  // Return null when ampersand is not immediately followed by `var(...)`.
  if (!adjacentReference) {
    return null
  } else {
    // Return adjacent token metadata for exact `&var(...)`.
    return {
      tokenStart: startIndex,
      raw: source.slice(startIndex, adjacentReference.end),
      hasAmpersandPrefix: true,
      reference: adjacentReference,
    }
  }
}
